
<app-nav class="w-100"></app-nav>
<div class="banner-bredcrum">
<section class="banner">
  <div #air id="air" class="air"></div>
  <div class="d-flex flex-column justify-content-center align-items-center w-100 rel-index">
  <h1 class="col-12 text-center loginBox v4-color-white">
    {{ "Knowledge Library" | translator }}
  </h1>
</div>
</section>
</div>

<div class="container-fluid kl-page">
  <!-- Breadcrumb -->
  <nav class="kl-breadcrumb">
    <a routerLink="/">{{ "KL Breadcrumb Home" | translator }}</a>
    <span class="kl-breadcrumb-sep">/</span>
    <span>{{ "Knowledge Library" | translator }}</span>
  </nav>

  <div class="kl-card">
    <!-- Header: title + page actions -->
    <div class="kl-card-header">
      <h2 class="kl-title">{{ "Content Management" | translator }}</h2>
      <div class="kl-header-actions">
        <button *ngIf="permissionService.hasPermission('KNOWLEDGE_LIBRARY_CATEGORY', 'r')"
          routerLink="/dashboard/knowledge-library/category" class="kl-btn kl-btn-outline">
          <i class="pi pi-sitemap"></i>{{ "Classification modification" | translator }}
        </button>
        <button *ngIf="hasPermission('c')" (click)="openCreateModal()" class="kl-btn kl-btn-primary">
          <i class="pi pi-plus-circle"></i>{{ "A new addition" | translator }}
        </button>
        <button routerLink="/knowledge-library" class="kl-btn kl-btn-outline">
          <i class="pi pi-replay"></i>{{ "Back" | translator }}
        </button>
      </div>
    </div>

    <div class="kl-card-body">
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>

      <!-- Toolbar: search, filter, reset, export -->
      <div class="kl-toolbar">
        <div class="kl-search">
          <i class="pi pi-search"></i>
          <input type="text" [(ngModel)]="searchterm" (ngModelChange)="onSearch()"
            placeholder="{{ 'Search by content title or file name' | translator }}" />
        </div>
        <div class="kl-toolbar-actions">
          <button class="kl-btn kl-btn-icon" [class.active]="showFilters || hasActiveFilters" (click)="showFilters = !showFilters"
            [attr.aria-expanded]="showFilters" [attr.aria-label]="'Filter' | translator" [pTooltip]="'Filter' | translator"
            tooltipPosition="top">
            <i class="pi pi-filter"></i>
          </button>
          <button class="kl-btn kl-btn-outline" (click)="reset()">
            <i class="pi pi-rotate-right"></i>{{ "Reset" | translator }}
          </button>
          <button class="kl-btn kl-btn-secondary" (click)="exportExcel()" [disabled]="data.length == 0">
            <i class="pi pi-file-export"></i>{{ "Export" | translator }}
          </button>
        </div>
      </div>

      <!-- Filters, opened from the toolbar filter button -->
      <div class="kl-filters" *ngIf="showFilters">
        <div class="row g-2">
          <div class="col-md-6 col-12">
            <p-dropdown class="ppp-dropdown-grey" [options]="availableCategories" optionLabel="label"
              (ngModelChange)="handleFilter('CATEGORY_FILTER', $event)" [(ngModel)]="category"
              placeholder="{{ 'Category' | translator }}"></p-dropdown>
          </div>
          <div class="col-md-6 col-12">
            <p-dropdown class="ppp-dropdown-grey" [(ngModel)]="selectedOU" appendTo="body" optionLabel="name"
              (ngModelChange)="handleFilter('OU_FILTER', selectedOU)" [options]="availableOus"
              placeholder="{{ 'Choose an organizational unit' | translator }}" [filter]="true">
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img *ngIf="checkisImg(node.image); else elseBlock" src="{{ staticURL }}{{ node.image }}"
                    class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
                  <ng-template #elseBlock>
                    <i class="{{ node.image }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.name }}</b>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="col-md-6 col-12">
            <p-calendar class="ppp-calander" styleClass="ppp-calander w-100 h-100" dir="ltr"
              (ngModelChange)="handleFilter('DATE_FROM_FILTER', $event)" [(ngModel)]="fromDate" [showIcon]="true"
              placeholder="{{ 'starting date' | translator }}"></p-calendar>
          </div>
          <div class="col-md-6 col-12">
            <p-calendar class="ppp-calander" styleClass="ppp-calander w-100 h-100" dir="ltr"
              (ngModelChange)="handleFilter('DATE_TO_FILTER', $event)" [minDate]="fromDate" [(ngModel)]="toDate"
              [showIcon]="true" placeholder="{{ 'Expiry date' | translator }}"></p-calendar>
          </div>
        </div>
      </div>

      <app-skelitions [hidden]="!preloader" [value]="2"></app-skelitions>
      <app-no-data *ngIf="!preloader && searchedData.length == 0"></app-no-data>

      <!-- Table -->
      <div class="kl-table-wrapper" *ngIf="!preloader && searchedData.length > 0">
        <table class="kl-table">
          <thead>
            <tr>
              <th class="kl-col-index">#</th>
              <th>{{ "Title" | translator }}</th>
              <th>{{ "Category" | translator }}</th>
              <th>الجهة</th>
              <th>اسم الملف</th>
              <th>{{ "Uploaded by" | translator }}</th>
              <th>التاريخ</th>
              <th>تاريخ التحديث</th>
              <th class="kl-col-actions">{{ "Actions" | translator }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of pagedData; let i = index">
              <td class="kl-col-index">{{ (currentPage - 1) * pageSize + i + 1 }}</td>
              <td class="kl-col-title">
                <div class="kl-title-cell">
                  <img *ngIf="checkisImg(row['الصورة']?.i)" src="{{ staticURL }}{{ row['الصورة']?.i }}"
                    class="kl-thumb" alt="" (error)="$any($event.target).hidden = true" />
                  <span class="kl-title-text">{{ row['العنوان']?.n }}</span>
                </div>
              </td>
              <td>
                <span class="kl-category">
                  <i *ngIf="row['التصنيف']?.i" class="{{ row['التصنيف']?.i }}"></i>{{ row['التصنيف']?.n }}
                </span>
              </td>
              <td class="kl-col-wrap">{{ row['وحدة تنظيمية ']?.n }}</td>
              <td>
                <div class="kl-file-cell" *ngIf="fileLinksOf(row) as files">
                  <span class="kl-file" *ngIf="files.length > 0" [pTooltip]="files[0].name" tooltipPosition="top">
                    <i [ngClass]="fileIcon(files[0])" class="kl-file-icon"
                      [attr.data-ext]="fileExt(files[0])"></i>
                    <span class="kl-file-name">{{ files[0].name }}</span>
                  </span>
                  <button *ngIf="files.length > 1" class="kl-file-more" (click)="openFilesPanel($event, row)">
                    +{{ files.length - 1 }}
                  </button>
                  <span *ngIf="files.length == 0" class="kl-muted">—</span>
                </div>
              </td>
              <td class="kl-muted">{{ row['تم الرفع بواسطة']?.n }}</td>
              <td class="kl-date">{{ row['التاريخ']?.n }}</td>
              <td class="kl-date">{{ row['تاريخ التحديث']?.n }}</td>
              <td class="kl-col-actions">
                <div class="kl-actions">
                  <button class="kl-action-btn" [pTooltip]="'View' | translator" tooltipPosition="bottom"
                    routerLink="/knowledge-library" [queryParams]="{ id: row['#'].n }">
                    <i class="pi pi-eye"></i>
                  </button>
                  <button *ngIf="rowDownloads.get(row['#'].n) as progress; else idleDownload"
                    class="kl-action-btn kl-downloading" disabled [pTooltip]="'Loading...' | translator"
                    tooltipPosition="bottom">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span *ngIf="progress.total > 1" class="kl-download-count">{{ progress.done }}/{{ progress.total }}</span>
                  </button>
                  <ng-template #idleDownload>
                    <button class="kl-action-btn" [pTooltip]="'Download' | translator" tooltipPosition="bottom"
                      [disabled]="fileLinksOf(row).length == 0" (click)="downloadFiles(row)">
                      <i class="pi pi-download"></i>
                    </button>
                  </ng-template>
                  <button *ngIf="rowMenuItems(row).length > 0" class="kl-action-btn"
                    (click)="openRowMenu($event, row)">
                    <i class="pi pi-ellipsis-v"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="kl-pagination" *ngIf="!preloader && searchedData.length > 0">
        <div class="kl-page-info">
          <span>
            {{ "Showing" | translator }} {{ pageStart }} – {{ pageEnd }} {{ "of" | translator }}
            {{ searchedData.length }} {{ "KL items" | translator }}
          </span>
          <span class="kl-per-page">
            {{ "per page" | translator }}
            <span class="kl-select">
              <select [(ngModel)]="pageSize" (ngModelChange)="currentPage = 1">
                <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
              </select>
              <i class="pi pi-chevron-down"></i>
            </span>
          </span>
        </div>
        <div class="kl-pages">
          <button class="kl-page-btn" [disabled]="currentPage == 1" (click)="goToPage(currentPage - 1)">
            <i class="pi pi-angle-right"></i>
          </button>
          <button *ngFor="let page of pageNumbers" class="kl-page-btn" [class.active]="page == currentPage"
            [disabled]="page == -1" (click)="goToPage(page)">
            {{ page == -1 ? "…" : page }}
          </button>
          <button class="kl-page-btn" [disabled]="currentPage == totalPages" (click)="goToPage(currentPage + 1)">
            <i class="pi pi-angle-left"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openModal" [style]="{ width: '95vw' , maxWidth: '1000px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "A new addition" | translator }}</span>
  </ng-template>
  <app-dynamic-form *ngIf="questions.length > 0 || updateQuestion.length > 0" (deleteLink)="handleDeleteLink($event)"
    [questions]="updateQuestion.length > 0 ? updateQuestion : questions" (sendData)="handleCreateUpdate($event)"
    (fileUploadMessage)="handleFileUplodMessage($event)"></app-dynamic-form>
  <p-messages [(value)]="formMessages" [enableService]="false"></p-messages>
</p-dialog>

<p-overlayPanel #filesPanel appendTo="body" styleClass="kl-files-panel" (onHide)="onFilesPanelHide()">
  <ng-template pTemplate="content">
    <div class="kl-files-panel-title">{{ activeFilesTitle }}</div>
    <ul class="kl-files-list">
      <li *ngFor="let file of activeFiles">
        <i [ngClass]="fileIcon(file)" class="kl-file-icon"
          [attr.data-ext]="fileExt(file)"></i>
        <span class="kl-files-list-name" [title]="file.name">{{ file.name }}</span>
        <a class="kl-action-btn" [href]="fileHref(file)" target="_blank" rel="noopener"
          [pTooltip]="'View' | translator" tooltipPosition="left">
          <i class="pi pi-eye"></i>
        </a>
        <button class="kl-action-btn" [pTooltip]="'Download' | translator" tooltipPosition="left"
          [disabled]="fileDownloads.has(file)" (click)="downloadFile(file)">
          <i class="pi" [ngClass]="fileDownloads.has(file) ? 'pi-spin pi-spinner' : 'pi-download'"></i>
        </button>
      </li>
    </ul>
  </ng-template>
</p-overlayPanel>

<p-menu #rowMenu [model]="activeRowMenu" [popup]="true" appendTo="body" styleClass="kl-row-menu"></p-menu>

<p-confirmDialog [style]="{ width: '50vw' }" [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"></p-confirmDialog>

<app-footer></app-footer>
